/* ==========================================================================
   ProductCardLeiRxjs > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    active: 0,
    disable: 1
};

/* Reducer */
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.DESTROY:
            return state;
        case types.ACTIVE_TAB:
            return {
                ...state,
                active: action.payload
            };
        case types.DISABLE_TAB:
            return {
                ...state,
                disable: action.payload
            };
        default:
            return state;
    }
}

/* Exports */
module.exports = {
    reducer
};
